import { hasStringKey } from "@/utils/misc";
import { LABEL_TEXT, TOOLTIP_TEXT } from "./constants";
import Label from "@ingka/label";
import LabelWithToolTip from "@/components/LabelWithTooltip/LabelWithToolTip";
import { CustomSelect } from "@/components/CustomSelect/CustomSelect";
import InputTextField from "@/components/InputTextField/InputTextField";
import { useMetadataFields } from "@/components/MetadataFields/hooks";
import {
  FieldAccessContext,
  isLockedForNonIngkaUser,
  isLockedForOwner,
  isProducedByLocalOrAgency,
  isUploadFinalized,
} from "@/components/MetadataFields/formFieldsAccessRules";

type Props = {
  fieldAccessContext: FieldAccessContext;
  options: Record<string, string>;
};

const CampaignOrDeliveryName = ({ options, fieldAccessContext }: Props) => {
  const {
    getValidationError,
    activeAsset,
    updateMetadata,
    isMetadataUpdating,
  } = useMetadataFields();

  const error =
    getValidationError("deliveryName", activeAsset.id!) ||
    getValidationError("userDeliveryName", activeAsset.id!);

  const isUpdating =
    isMetadataUpdating(activeAsset.id!, "userDeliveryName") ||
    isMetadataUpdating(activeAsset.id!, "deliveryName");

  const ctx = { ...fieldAccessContext, producedBy: activeAsset.producedBy };
  const isDisabled =
    isLockedForOwner(fieldAccessContext) ||
    isUploadFinalized(fieldAccessContext) ||
    isLockedForNonIngkaUser(ctx) ||
    isProducedByLocalOrAgency(ctx) ||
    isUpdating;

  const selectedValue = activeAsset.deliveryName || "";

  return (
    <>
      {fieldAccessContext.isAdmin ? (
        <>
          <Label
            htmlFor="admin-delivery-name-id"
            label={
              <LabelWithToolTip
                labelText={LABEL_TEXT}
                toolTipText={TOOLTIP_TEXT}
              />
            }
          />
          <CustomSelect
            id="admin-delivery-name-id"
            disabled={isDisabled}
            errorMessage={error?.message}
            value={{ label: options[selectedValue], value: selectedValue }}
            helperMessage={
              activeAsset.userDeliveryName
                ? `User input: ${activeAsset.userDeliveryName}`
                : ""
            }
            options={Object.entries(options).map(([value, label]) => ({
              label,
              value,
            }))}
            onChange={(option) => {
              if (hasStringKey("value", option)) {
                updateMetadata({
                  deliveryName: option.value,
                });
              }
            }}
          />
        </>
      ) : (
        <InputTextField
          id="user-delivery-name-id"
          labelText={LABEL_TEXT}
          toolTipText={TOOLTIP_TEXT}
          initialValue={activeAsset.userDeliveryName || ""}
          disabled={isDisabled}
          shoudlValidate={Boolean(error)}
          errorMessage={error?.message}
          onBlur={(value: string) =>
            updateMetadata({
              userDeliveryName: value,
            })
          }
        />
      )}
    </>
  );
};

export default CampaignOrDeliveryName;
